require(["jquery", "antiForgeryTokenHelper", "utility"], function ($, antiForgeryTokenHelper, utilty) {

    const LEFT_MENU_OPENED_POSITION = 0;
    const LEFT_MENU_CLOSED_POSITION = -200;
    const APP_CONTAINER_OPENED_POSITION = 0;
    const APP_CONTAINER_CLOSED_POSITION = 200;
    const ANIMATION_DURATION_MS = 300;

    $(function () {
        $("#helpBar").on("click", function (event) {
            event.preventDefault();
            $("#helpbarDashboard").toggle();
        });

        $("#mobile-menu").on("click", function (event) {
            event.preventDefault();
            toggleApplicationContainer(".application");
            $("html").addClass("intro"); 
            $("html, body").addClass("disable-scrolling");
            toggleSubMenu("#sidebar");

            event.stopPropagation();
            $('html').one('click', function () {
                hideSubMenu();
                $("html").removeClass("intro");
                $("html, body").removeClass("disable-scrolling");
                event.preventDefault();
                event.stopPropagation();
            });
            $("#sidebar").click(function (e) {
                e.stopPropagation();
            });
        });
    });


    $(function () {

        var active_item = localStorage.getItem('active_item');
        if (active_item !== null) {
            $('#' + active_item).siblings().find(".active").removeClass("active");
            if (window.location.href.indexOf("partneruserprofile") == -1) {
                $('#' + active_item).addClass("active");
            }
        }

        $(".btn-group button").click(function () {
            var id = $(this).attr("id");

            localStorage.setItem("active_item", id);

            $('#' + id).siblings().find(".active").removeClass("active");
        });

    });

    function toggleSubMenu(element) {

        if ($(element).css("left") == LEFT_MENU_CLOSED_POSITION + "px") {
            $(element).animate({ left: LEFT_MENU_OPENED_POSITION }, ANIMATION_DURATION_MS);

        } else {

            $(element).animate({ left: LEFT_MENU_CLOSED_POSITION }, ANIMATION_DURATION_MS);
        }
        $("#sidebar").removeClass("visible");
    };

    function toggleApplicationContainer(element) {

        if ($(element).css("left") == APP_CONTAINER_CLOSED_POSITION + "px") {
            $(element).animate({ left: APP_CONTAINER_OPENED_POSITION }, ANIMATION_DURATION_MS);

        } else {

            $(element).animate({ left: APP_CONTAINER_CLOSED_POSITION }, ANIMATION_DURATION_MS);
        }
        $(".application").removeClass("visible");
    };

    function hideSubMenu() {
        if ($("#sidebar").css("left") == LEFT_MENU_OPENED_POSITION + "px") {
            $("#sidebar").animate({ left: LEFT_MENU_CLOSED_POSITION }, ANIMATION_DURATION_MS);
            $(".application").animate({ left: LEFT_MENU_OPENED_POSITION }, ANIMATION_DURATION_MS);
        }
    };

    // Clear styles on window resize 
    $(window).on("resize", function () {
        var viewportWidth = $(window).width();
        var viewportHeight = $(window).height();
        
        $("#divMainContent").height(viewportHeight - 65);

        if (viewportWidth > 750) {
            $("#sidebar").attr({ style: "" });
            $(".application").attr({ style: "" });
            $("#sidebar").removeClass("visible");
            $("html").removeClass("intro");
        }
        if (viewportWidth < 750) {
            $("#sidebar").attr({ style: "" });
            $(".application").attr({ style: "" });
            $("body").removeClass("iconSidebar");
            $("html").removeClass("intro");

        }

    }).resize();

    // Session Timeout.
    $(document).ajaxError(function (xhr, props) {
        if (props.status === 499) {
            utility.logNonProd(props);
            location.reload(true);
        }
    });

    $(document).ready(function () {

        if (typeof antiForgeryTokenHelper !== "undefined") {
            // Will include antiForgeryToken as part of all request
            //__RequestVerificationToken is the name of the hidden field
            $.ajaxSetup({
                headers: {
                    'RequestVerificationToken': antiForgeryTokenHelper.getAntiForgeryToken(),
                    'Access-Control-Allow-Origin': new URL(window.location.href).origin
                }
            });
        }
        else {
            utility.logNonProd("antiForgeryTokenHelper is UNDEFINED");
        }

        var deviceAgent = navigator.userAgent.toLowerCase();
        var isApplePortableDevice = deviceAgent.match(/(iPad|iPhone|iPod)/i);
        if (isApplePortableDevice) {
            $('.container-fluid').css('-webkit-overflow-scrolling', 'touch');
        }

    });

});



